<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Order.Fields.batchApproveError") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table 
        :headers="headers"
        :items="Items"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
      >
        <template v-slot:header.action="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Shop.Fields.choose") }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-chip small label>
              <!-- :color="item.status | shopStatusColor"
              :text-color="item.status | shopStatusTextColor" -->
              {{ item.status | shopStatusText }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "DialogShop",

  props: {
    value: Boolean,
    Items: Array,
    isActivity: Boolean,
  },
  computed: {
    headers() {
      return [
        {
          text: i18n.t("Order.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("Order.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("Order.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("Order.Fields.order_unit"),
          align: "start",
          sortable: false,
          value: "order_unit",
        },
        {
          text: i18n.t("Order.Fields.supplier_name"),
          align: "start",
          sortable: false,
          value: "supplier_name",
        },
        {
          text: i18n.t("Order.Fields.purchase_unit"),
          align: "start",
          sortable: false,
          value: "purchase_unit",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>
